import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import BaseText from '../BaseText';
import Images from '../../constants/Images';
import RowView from '../RowView';
import { CommonStyles, CommonProperties } from '../../styles';
import { scale } from 'react-native-size-matters';
const ChangeAirReceiptCard = ({ item = {} }) => {
  return (
    <View>
      {item?.AirSegments.map((airSegment, index) => {
        return (
          <RowView key={index} style={CommonStyles.pt5}>
            <View>
              <Image
                style={styles.leftImage}
                source={
                  airSegment.IsMultipleAirline
                    ? Images.air['74x74']['Multiple-Airlines']
                    : Images.air['74x74'][airSegment.AirlineCode]
                }
              />
            </View>
            <View>
              <BaseText>
                {airSegment?.AirlineName} #{airSegment?.FlightNumber}
              </BaseText>
              <BaseText>
                {airSegment?.DepartureAirportCode} - {airSegment?.DepartureDate}{' '}
                {airSegment?.DepartTime}{' '}
              </BaseText>
              <BaseText>
                {' '}
                {airSegment?.ArrivalAirportCode} - {airSegment?.ArrivalDate}{' '}
                {airSegment?.ArrivalTime}
              </BaseText>
              <BaseText> {airSegment?.AirCabinClass}</BaseText>
            </View>
          </RowView>
        );
      })}
    </View>
  );
};
const styles = StyleSheet.create({
  leftImage: {
    ...CommonProperties.mt4,
    ...CommonProperties.mr3,
    ...CommonProperties.ml2,
    height: scale(40),
    width: scale(40),
  },
});

export default ChangeAirReceiptCard;
